import React from 'react'
import { useSelector } from 'react-redux'

import '../../css/manager_alert.css'

const ManagersAlert = ({ text }) => {
    const { role } = useSelector(state => state.user.admin.user)
    
    return (
        role === 'manager' 
            ? <div className='manager-alert'>
                <b>Alert:</b> 
                {!!text ? (' ' + text) : " This form is read-only for specialists. Any changes made won't be saved."}
            </div>
            : <React.Fragment></React.Fragment>
    )
}

export default ManagersAlert


// WEBPACK FOOTER //
// ./src/components/utils/ManagersAlert.js